/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespHeroCarousel_viewer = {|
  +isRequestMoreImagesEnabled: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarousel_viewer",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespZoomModal_viewer",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": "isRequestMoreImagesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "REQUEST_MORE_IMAGES",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"REQUEST_MORE_IMAGES\"}"
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
